/* Mikaya — About page motion. Reveals/parallax/count-up applied here so the
   page content stays pure structure. Namespaced, idempotent, reduced-motion. */
(function () {
  function init() {
    var root = document.querySelector('.mk-about');
    if (!root || root.dataset.mkAboutReady) return;
    root.dataset.mkAboutReady = '1';
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // scroll progress bar
    var prog = document.createElement('div');
    prog.className = 'mk-about__progress';
    document.body.appendChild(prog);
    function onProg() {
      var t = document.documentElement.scrollHeight - window.innerHeight;
      prog.style.width = (t > 0 ? (window.scrollY / t) * 100 : 0) + '%';
    }

    // assign reveal hooks (kept out of the content HTML)
    var map = [
      ['.mk-about__hero > *', ''], ['.mk-about__h1', 'fade'],
      ['.mk-about__story-inner > *', ''],
      ['.mk-about__quote-text', 'scale'], ['.mk-about__quote-attr', ''],
      ['.mk-about__portrait', 'scale'], ['.mk-about__name', ''], ['.mk-about__role', ''],
      ['.mk-about__founder-quote', ''], ['.mk-about__founder-story', ''],
      ['.mk-about__phil-head > *', ''], ['.mk-about__phil-item--mission', 'left'], ['.mk-about__phil-item--vision', 'right'],
      ['.mk-about__values-head > *', ''], ['.mk-about__value', ''],
      ['.mk-about__craft-item', ''], ['.mk-about__close-text', 'scale'], ['.mk-about__close-link', '']
    ];
    map.forEach(function (pair) {
      root.querySelectorAll(pair[0]).forEach(function (el, i) {
        if (el.hasAttribute('data-r')) return;
        el.setAttribute('data-r', pair[1]);
        if (i) el.style.transitionDelay = (Math.min(i, 4) * 0.08) + 's';
      });
    });

    var reveals = root.querySelectorAll('[data-r]');
    if (reduce || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('in'); });
      onProg();
      window.addEventListener('scroll', onProg, { passive: true });
      return;
    }

    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    reveals.forEach(function (el) { io.observe(el); });

    // count-up on craft numbers (honest values; non-numeric left as typed)
    function countUp(el) {
      var m = el.textContent.trim().match(/^(\d+)(.*)$/);
      if (!m) return;
      var target = parseInt(m[1], 10), suffix = m[2] || '', start = null, dur = 1200;
      function step(t) {
        if (start === null) start = t;
        var p = Math.min((t - start) / dur, 1), e = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * e) + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    var cio = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { countUp(e.target); cio.unobserve(e.target); } });
    }, { threshold: 0.4 });
    root.querySelectorAll('.mk-about__craft-num').forEach(function (n) { cio.observe(n); });

    // gentle parallax on the story video
    var vid = root.querySelector('.mk-about__video');
    var ticking = false;
    function onScroll() {
      onProg();
      if (ticking || !vid) return;
      ticking = true;
      requestAnimationFrame(function () {
        var b = vid.parentElement.getBoundingClientRect(), vh = window.innerHeight;
        if (b.bottom > -vh && b.top < 2 * vh) {
          var shift = ((vh - b.top) / (vh + b.height) - 0.5) * -30;
          vid.style.transform = 'translateY(' + shift.toFixed(1) + 'px) scale(1.08)';
        }
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onProg();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
